export enum ESupportedLanguage {
  CHINESE = 'zh',
  ENGLISH = 'en',
  GERMAN = 'de',
  JAPANESE = 'ja',
  PORTUGUESE = 'pt',
  SPANISH = 'es',
  VIETNAMESE = 'vi',
}

export enum ESupportedRegionLanguage {
  CHINESE_SIMPLE = 'zh-CN',
  ENGLISH_US = 'en-US',
  GERMAN_GERMANY = 'de-DE' /* todo:  support multiple language report */,
  JAPANESE_JAPAN = 'ja-JP' /* todo:  support multiple language report */,
  PORTUGUESE_PORTUGAL = 'pt-PT',
  SPANISH_SPAIN = 'es-ES',
  VIETNAMESE_VIETNAM = 'vi-VN',
}
